<template>
  <div class="c-copy">
    <div v-if="copied" class="c-copy__content--copied is-hidden-touch">
      <base-icon width="24px" height="24px" :name="'checked'" /> copiado
    </div>
    <div class="c-copy__content">
      <input
        id="textToCopy"
        ref="clone"
        class="c-copy__input"
        v-model="qrCode"
      />

      <button
        class="c-copy__button"
        v-clipboard:copy="qrCode"
        v-clipboard:success="textCopied"
      >
        <base-icon name="copy" width="24px" height="24px" />
        Copiar
      </button>
    </div>
    <p v-if="copied" class="is-hidden-desktop c-copy__content--text-copied">
      Copiado!
    </p>
  </div>
</template>

<script>
export default {
  props: {
    qrCode: {
      type: String,
      require: true,
    },
  },

  data() {
    return {
      copied: false,
    }
  },

  methods: {
    textCopied() {
      this.copied = true

      setTimeout(() => {
        this.copied = false
      }, 2000)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-copy {
  position: relative;
  margin-top: 16px;
  margin-bottom: 16px;

  @media (min-width: $tablet) {
    margin-bottom: 32px;
    margin-top: 0;
  }

  &__content {
    padding: 8px 14px 8px 10px;
    border-radius: 8px;
    border: solid 1px #dee7ea;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &--text-copied {
      text-align: center;
      color: $support;
      font-size: 14px;
    }

    &--copied {
      position: absolute;
      right: -105px;
      top: 0;
      padding: 8px;
      border-radius: 4px;
      box-shadow: 0 4px 7px 0 rgba(191, 200, 209, 0.39);
      border: solid 1px #92c959;
      font-size: 14px;
      color: #92c959;
      font-weight: bold;
      line-height: 1.36;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 98px;

      svg {
        margin-right: 4px;
      }
    }
  }

  &__input {
    width: 100%;
    border: none;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Lato;
    font-size: 14px;
    color: #8493a2;
    margin-right: 16px;
  }

  &__button {
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: #3dafb0;
    line-height: 1.14;
    cursor: pointer;

    svg {
      margin-right: 8px;
    }
  }
}
</style>
